import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader, Field, Toggle, Select, TextArea } from "./_helpers";
import MediaPicker from "@/components/admin/MediaPicker";
import { toast } from "sonner";
import { toYouTubeEmbed, isYouTubeUrl } from "@/lib/youtube";
import { Info, Eye } from "lucide-react";

export default function AdminTV() {
  const [streams, setStreams] = useState([]);
  const [programs, setPrograms] = useState([]);
  const empty = { title: "", description: "", stream_url: "", stream_type: "youtube", is_live: true, is_active: true, province_id: "" };
  const [s, setS] = useState(empty);
  const emptyP = { title: "", description: "", youtube_url: "", schedule_day: "", schedule_time: "", image: "", is_active: true };
  const [p, setP] = useState(emptyP);
  const [preview, setPreview] = useState(false);
  const load = () => { api.get("/tv/live").then((r) => setStreams(r.data)); api.get("/tv/programs").then((r) => setPrograms(r.data)); };
  useEffect(load, []);

  const previewEmbed = s.stream_type === "youtube" && s.stream_url ? toYouTubeEmbed(s.stream_url) : s.stream_url;

  return (
    <div>
      <AdminPageHeader title="TV & Canlı Yayın" />
      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bg-white border border-gray-100 rounded-lg p-4">
          <h3 className="font-bold mb-3">Canlı Yayınlar</h3>
          {streams.map((sm) => (
            <div key={sm.id} className="flex items-center justify-between py-2 border-b">
              <div><div className="font-semibold text-sm">{sm.title}</div><div className="text-xs text-gray-500">{sm.stream_type} {sm.is_live ? "— CANLI" : ""}</div></div>
              <button onClick={async () => { await api.delete(`/tv/live/${sm.id}`); load(); }} className="text-red-500 text-xs">Sil</button>
            </div>
          ))}
          <div className="mt-3 space-y-2">
            <h4 className="font-semibold text-sm">Yeni Canlı Yayın</h4>
            <div className="bg-blue-50 border border-blue-200 rounded p-3 text-xs text-blue-900 flex gap-2">
              <Info className="w-4 h-4 shrink-0 mt-0.5" />
              <div>
                <strong>YouTube canlı yayın için:</strong> Standart link (<code className="bg-white px-1 rounded">https://www.youtube.com/watch?v=...</code> veya <code className="bg-white px-1 rounded">/live/...</code>) yapıştırın — sistem otomatik <code className="bg-white px-1 rounded">/embed/</code> formatına dönüştürür.<br/>
                <strong>Kanal canlı yayını için</strong> (kanal anlık ne yayınlıyorsa): <code className="bg-white px-1 rounded">https://www.youtube.com/embed/live_stream?channel=KANAL_ID</code>
              </div>
            </div>
            <Field label="Başlık" value={s.title} onChange={(e) => setS({ ...s, title: e.target.value })} />
            <Field label="Stream URL" placeholder="https://www.youtube.com/watch?v=..." value={s.stream_url} onChange={(e) => setS({ ...s, stream_url: e.target.value })} />
            {s.stream_url && s.stream_type === "youtube" && (
              <div className="bg-gray-50 rounded p-2 text-[11px] break-all">
                <div className="text-gray-500 mb-0.5">Otomatik embed URL:</div>
                <code className="text-gray-800">{previewEmbed}</code>
                {!isYouTubeUrl(s.stream_url) && <div className="text-amber-700 mt-1">⚠ Bu YouTube URL'i gibi görünmüyor</div>}
              </div>
            )}
            <Select label="Tip" value={s.stream_type} options={[{ value: "youtube", label: "YouTube" }, { value: "hls", label: "HLS" }, { value: "rtmp", label: "RTMP" }]} onChange={(e) => setS({ ...s, stream_type: e.target.value })} />
            <TextArea rows={2} label="Açıklama" value={s.description} onChange={(e) => setS({ ...s, description: e.target.value })} />
            <Toggle label="Canlı" value={s.is_live} onChange={(v) => setS({ ...s, is_live: v })} />
            <Toggle label="Aktif" value={s.is_active} onChange={(v) => setS({ ...s, is_active: v })} />
            <div className="flex gap-2">
              <button onClick={() => setPreview(!preview)} disabled={!s.stream_url} className="px-3 py-2 border border-gray-200 rounded text-sm flex items-center gap-1"><Eye className="w-4 h-4" /> {preview ? "Önizlemeyi Kapat" : "Önizle"}</button>
              <button onClick={async () => { try { await api.post("/tv/live", s); setS(empty); load(); toast.success("Eklendi"); } catch { toast.error("Hata"); } }} className="flex-1 px-4 py-2 bg-[#e11d2a] text-white rounded text-sm font-semibold">Ekle</button>
            </div>
            {preview && previewEmbed && (
              <div className="aspect-video bg-black rounded mt-2 overflow-hidden">
                <iframe src={previewEmbed} title="preview" className="w-full h-full" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            )}
          </div>
        </div>
        <div className="bg-white border border-gray-100 rounded-lg p-4">
          <h3 className="font-bold mb-3">Programlar</h3>
          {programs.map((pr) => (
            <div key={pr.id} className="flex items-center justify-between py-2 border-b">
              <div><div className="font-semibold text-sm">{pr.title}</div><div className="text-xs text-gray-500">{pr.schedule_day} {pr.schedule_time}</div></div>
              <button onClick={async () => { await api.delete(`/tv/programs/${pr.id}`); load(); }} className="text-red-500 text-xs">Sil</button>
            </div>
          ))}
          <div className="mt-3 space-y-2">
            <h4 className="font-semibold text-sm">Yeni Program</h4>
            <Field label="Başlık" value={p.title} onChange={(e) => setP({ ...p, title: e.target.value })} />
            <TextArea rows={2} label="Açıklama" value={p.description} onChange={(e) => setP({ ...p, description: e.target.value })} />
            <Field label="YouTube URL" value={p.youtube_url} onChange={(e) => setP({ ...p, youtube_url: e.target.value })} />
            <div className="grid grid-cols-2 gap-2">
              <Field label="Gün" value={p.schedule_day} onChange={(e) => setP({ ...p, schedule_day: e.target.value })} />
              <Field label="Saat" value={p.schedule_time} onChange={(e) => setP({ ...p, schedule_time: e.target.value })} />
            </div>
            <Field label="Görsel URL (isteğe bağlı)" value={p.image} onChange={(e) => setP({ ...p, image: e.target.value })} />
            <div>
              <label className="block text-xs font-medium mb-1 text-gray-600">Program görseli (havuzdan)</label>
              <MediaPicker
                value={p.image}
                onChange={(u) => setP({ ...p, image: u })}
                scope="tv"
                testId="tv-program-image-picker"
              />
            </div>
            <button onClick={async () => { try { await api.post("/tv/programs", p); setP(emptyP); load(); toast.success("Eklendi"); } catch { toast.error("Hata"); } }} className="w-full px-4 py-2 bg-[#e11d2a] text-white rounded text-sm font-semibold">Ekle</button>
          </div>
        </div>
      </div>
    </div>
  );
}
